import styled from "styled-components";
import { Row, Col } from "antd";
import {
    DataValue,
    PagesHeading,
    WhiteGradient
  } from "../../CommonComponents/commonStyles";


export const NewsPageContainer = styled.div`
  padding: 0px 140px;
  @media (max-width: 321px){
      padding-top: 10px !important;
  }
  @media (max-width: 1024px) {
    padding: 0px 22px;
  }
`;

export const EmptyMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 250px;
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  color: ${props => props.theme.fontColors.textColor};
`

export const PageHeading = styled(PagesHeading)`
    font-family: BerkeleyStd-Book;
    font-size: 42px;
    line-height: 1.14;
    letter-spacing: 0.5px;
    color: #3022737;
    @media (max-width: 576px) {
        font-size: 36px;
        line-height: 1.17;
        width: 101%;
    }
`;

export const SectionHeading = styled.h1`
    font-family: BerkeleyStd-Book;
    font-size: 30px;
    line-height: 1.2;
    letter-spacing: 0.5px;
    color: #022737;
    padding-top: 20px;
    @media (max-width: 576px) {
        font-size: 24px;
        padding-top: 10px;
        margin-bottom: 20px;
    }
`;

export const SectionBody = styled.p`
    font-family: HelveticaNeue;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #505050;
    word-break: break-word;
    word-wrap: break-word;
    @media (max-width: 576px) {
        font-size: 14px;
        line-height: 1.43;
    }
`;

export const FundContainer = styled.div`
    padding-top: 30px;
    display: grid;
    @media (max-width: 576px) {
        display: block;
        padding-top: 22px;
    }
`;

export const FundHeader = styled.span`
    font-family: HelveticaNeue;
    font-size: 16px;
    line-height: 1.5;
    color: #505050;
    @media (max-width: 576px) {
        font-size: 14px;
        line-height: 1.43;
    }
`;

export const FundId = styled.span`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: 24px;
    letter-spacing: 0.8px;
    color: #505050;
    margin-bottom: 0px;
    line-height: normal;
    display: block;
    @media (max-width: 576px) {
        float: right;
        font-size: 20px;
        letter-spacing: 0.7px;
    }

`;

export const NewsDateDetailed = styled.span`
    font-family: HelveticaNeue;
    font-size: 16px;
    line-height: 1.5;
    color: #505050;
    @media (max-width: 576px) {
        font-size: 14px;
        line-height: 1.43;
    } 
`;

export const NewsDateShort = styled.span`
    font-family: HelveticaNeue;
    font-size: 14px;
    line-height: 1.43;
    letter-spacing: normal;
    color: #505050;
    padding-bottom: 5px;
`;

export const BriefHeader = styled.span`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};    
    font-size: 16px;
    line-height: 1.5;
    color: #022737;
    padding-bottom: 5px;
`;

export const BriefDesc = styled.p`
    font-family: HelveticaNeue;
    font-size: 16px;
    line-height: 1.5;
    color: #505050;
    word-break: break-word;
    word-wrap: break-word;
    @media (max-width: 576px){
        font-size: 14px;
    }
`;

export const BriefLink = styled.a`
    font-family: HelveticaNeue;
    font-size: 16px;
    line-height: 1.5;
    color: #006778;
    text-decoration: underline;
    float: right;
    &:hover {
        color: #006778;
        text-decoration: underline;
    }
    @media (max-width: 576px){
        font-size: 14px;
    }
`;

export const ArticlesContainer = styled.div`
    padding-top: 30px;
    @media (max-width: 576px){
        padding-top: 23px;
    }
`;

export const OuterRow = styled(Row)`
    min-height: 100%;
    ${props => !props.noBorder && "border-bottom: 1px solid #d4d4d4"}
`;

export const LeftCol = styled(Col)`
    border-top: 1px solid #d4d4d4;
    height: 814px;
    overflow-y: auto;
    @media (max-width: 576px) {
        border-top: none;
        // display: none;
        height : 100%
    }
    @media (min-width: 577px) and (max-width: 2560px) {
        display: block !important;
    }
`;

export const RightCol = styled(Col)`
    border-top: 1px solid #d4d4d4;
    height: 814px;
    overflow-y: auto;
    padding: 19px 32px 0px;
    border-left: 1px solid #d4d4d4;
    border-top: 1px solid #d4d4d4;
    @media (max-width: 576px) {
        // display: none;
        border-left: none;
        padding: 10px 0px;
        height : 100%
        margin-top:10px;
        border-top: none;
    }
    @media (min-width: 577px) and (max-width: 2560px) {
        display: block !important;
    }
`;

export const BriefNewsContainer = styled(Row)`
    padding: 19px 23px 20px 20px;
    border-bottom: 1px solid #d4d4d4;
    &:last-child {
        border-bottom: none;
    }
    @media (max-width: 576px) {
        padding: 20px 0px;
        padding-right: 30px;
    }
`;

export const SelectedBriefNewsContainer = styled(BriefNewsContainer)`
    background: #f4f3f3;
    @media (max-width: 576px) {
        background: none;
        padding-right: 30px;
    }
`;

export const BackContainer = styled.div`
    @media (min-width:577px) and (max-width:2560px){
        display: none;
    }
    @media (max-width: 576px) {
        border-top: 2px solid #d4d4d4;
        border-bottom: 2px solid #d4d4d4;
        padding: 10px 0px;
    }
`;

export const BackLink = styled.a`
    @media (min-width:577px) and (max-width:2560px){
        display: none;
    }
    @media (max-width: 576px) {
        font-family: HelveticaNeue;
        font-size: 14px;
        line-height: 1.43;
        color: #006778;
        text-decoration: underline;
        &:hover {
            color: #006778;
        }
    }
`;

export const BottomGradient = styled(WhiteGradient)`
    width: 100%;
    height: 39px;
    @media (max-width: 576px){
        display: none;
    }
`;

export const NewsPrintContainer = styled.div`
    @media (max-width: 576px) {
        padding-top:20px;
    }    
`;

export const PrintContainer = styled.div`
    float: right;
    @media (max-width: 576px) {
        padding-top:20px;
    }
`;

export const IconPadding = styled.div`
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  position: relative;
  @media (max-width: 426px){
      left: 20px !important;
  }
  @media (min-width: 427px) and (max-width: 769px){
      left: 32px !important;
  }
  @media (max-width: 1445px){
      left: 10px;
  }
  @media (max-width: 990px) {
    margin-left: 0px;
    margin-right: 26px;
  }
`;

export const DataExportPrint = styled(DataValue)`
  margin: 0px 5px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: normal;
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  display: block;
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: 14px;
    line-height: ${props => props.theme.lineHeight.secondary};
  }

`;